/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertFileSize',
})
export class UtilitiesConvertFileSizePipe implements PipeTransform {

    transform(bytes: number) {
        if (!+bytes) {
            return '0 Bytes'
        }
        const i = Math.floor(Math.log(bytes) / Math.log(1024))
        return `${parseFloat((bytes / Math.pow(1024, i)).toFixed(2))} ${['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][i]}`
    }

}
